<template>
  <div class="table-wrap">
    <table class="ui-table">
      <thead>
        <tr>
          <th v-for="col in columns" :key="col.key" :style="colStyle(col)">{{ col.label }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(row, i) in rows" :key="rowKey ? row[rowKey] : i">
          <tr
            class="ui-row"
            :class="{ clickable, 'is-expanded': isExpanded(row) }"
            @click="onRowClick(row, $event)"
          >
            <td v-for="col in columns" :key="col.key" :style="colStyle(col)" :class="col.cellClass">
              <slot :name="`cell-${col.key}`" :row="row" :value="row[col.key]" :index="i">{{ display(row, col) }}</slot>
            </td>
          </tr>
          <tr v-if="isExpanded(row)" class="ui-expand-row">
            <td :colspan="columns.length">
              <slot name="expanded" :row="row" />
            </td>
          </tr>
        </template>
        <tr v-if="!rows.length">
          <td :colspan="columns.length" class="empty-row">
            <slot name="empty">No data</slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    // columns: [{ key, label, align?, width?, cellClass? }]
    columns: { type: Array, required: true },
    rows: { type: Array, default: () => [] },
    rowKey: { type: String, default: '' },
    clickable: { type: Boolean, default: false },
    // rowKey value of the currently expanded row (null = none). Requires rowKey.
    // Render the expanded content via the #expanded slot.
    expandedKey: { type: [String, Number], default: null }
  },
  emits: ['row-click'],
  methods: {
    isExpanded(row) {
      return this.expandedKey != null && !!this.rowKey && row[this.rowKey] === this.expandedKey
    },
    colStyle(col) {
      return { textAlign: col.align || 'left', width: col.width || 'auto' }
    },
    display(row, col) {
      const v = row[col.key]
      return v === undefined || v === null || v === '' ? '—' : v
    },
    onRowClick(row, e) {
      if (this.clickable) this.$emit('row-click', row, e)
    }
  }
}
</script>

<style scoped>
.table-wrap { width: 100%; overflow-x: auto; }
.ui-table { width: 100%; border-collapse: separate; border-spacing: 0; }
.ui-table th,
.ui-table td { padding: 11px 14px; text-align: left; border-bottom: 1px solid var(--border-soft); }
.ui-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #191a2c;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-secondary);
  white-space: nowrap;
}
.ui-table tbody td { font-size: 13px; color: var(--text-primary); vertical-align: middle; }
.ui-row { transition: background-color 0.18s ease; }
.ui-row:hover { background: var(--hover-bg); }
.ui-row.clickable { cursor: pointer; }
.ui-row.is-expanded { background: rgba(var(--primary-rgb), 0.10); }
.ui-row.is-expanded td { border-bottom: none; }
.ui-expand-row > td { padding: 0; background: rgba(var(--primary-rgb), 0.05); border-bottom: 1px solid var(--border-soft); }
.ui-row:last-child td { border-bottom: none; }
.empty-row { text-align: center; color: var(--text-secondary); padding: 34px !important; }
</style>
